// @flow
import React, { Component } from 'react';
import { Button, Form, FormGroup, Col, ControlLabel } from 'react-bootstrap';

import TextInput from './components/TextInput/TextInput';
import Options from './components/Options/Options';
import style from './style/style';

import local from '../../../../locales/index';

class News extends Component<{
  user: Object,
}, {
  feeds: Array<string>,
}> {
  constructor(props: Object) {
    super(props);
    const settings = this.props.user.modules.news;
    this.state = {
      feeds: settings.rssFeeds,
    };
  }

  componentWillMount() {
    this.keys = this.state.feeds.map((e, index) => (index.toString()));
  }

  save(user: Object): Object {
    const newUser = user;
    newUser.modules.news.rssFeeds = this.state.feeds.filter(e => e.length > 0);
    return newUser;
  }

  addFeed() {
    const newFeeds = this.state.feeds;
    newFeeds.push('');
    this.keys.push(((new Date()).getTime()).toString());
    this.setState({ feeds: newFeeds });
  }

  remove(index: number) {
    const newFeeds = this.state.feeds;
    newFeeds.splice(index, 1);
    this.keys.splice(index, 1);
    this.setState({ feeds: newFeeds });
  }

  feedChanged(val: string, index: number) {
    const newFeeds = this.state.feeds;
    newFeeds[index] = val;
    this.setState({ feeds: newFeeds });
  }

  keys: Array<string>

  generateFields(): Array<TextInput> {
    return (this.state.feeds.map((feed, index) => (<TextInput
      feed={feed}
      key={this.keys[index]}
      placeholder={local.example}
      onChange={e => this.feedChanged(e, index)}
    />)));
  }

  generateButtons(): Array<Options> {
    return (this.state.feeds.map((feed, index) => (<Options
      onClick={() => this.remove(index)}
      key={`button${this.keys[index]}`}
      title={local.remove}
    />)));
  }

  render() {
    return (<div>
      <h4>{local.news}</h4>
      <Form horizontal>
        <FormGroup controlId="formHorizontalEmail">
          <Col componentClass={ControlLabel} sm={2}>
            {local.feeds}
          </Col>
          <Col sm={9}>
            {this.generateFields()}
            <Button onClick={() => this.addFeed()} bsStyle="primary">{local.add}</Button>
          </Col>
          <Col sm={1} style={style.options}>
            {this.generateButtons()}
          </Col>
        </FormGroup>
      </Form>
    </div>);
  }
}

export default News;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/News/News.js